export const basePrice = 150;
export const intensePrice = 95;
export const privacyPrice = 50;

export const defaultErrorMessage =
  "An unexpected error occurred, please try again later. If the issue persists, contact Support.";
